import { ARTICLE_PATHS } from "./articleUrls"

export const ADDITIONAL_REQUIREMENTS = {
  EXPERIENCE_CREDITS: {
    id: "experience_credits",
    title: "Experience Credits",
    description:
      "Experience credits come from your education and golf employment, including your current job.",
    linkText: "Learn more",
    linkUrl: ARTICLE_PATHS.EXPERIENCE_CREDITS,
  },

  EMPLOYMENT: {
    id: "employment",
    title: "Eligible Employment",
    description:
      "Update your current eligible golf employment so you can apply for Membership.",
    completeDescription:
      "Your current employment meets this Membership requirement.",
    primaryLinkText: "Update employment",
  },

  AGE: {
    id: "age",
    title: "Age Requirement",
    description:
      "You must be 18 or older to apply for Membership. Contact Membership Services if the date of birth on your record is incorrect.",
  },

  GOOD_STANDING: {
    id: "good_standing",
    title: "Dues and Good Standing",
    description: "Pay your unpaid dues so you can apply for Membership.",
    primaryLinkText: "Pay dues",
  },

  ACCEPTABLE_PROGRESS: {
    id: "acceptable_progress",
    title: "Path to Membership Window",
    description:
      "Your Path to Membership window has ended. Reapply for the Path to Membership.",
    primaryLinkText: "Reapply",
  },

  PAT: {
    id: "playing_ability_test",
    title: "Playing Ability Test",
    description:
      "Congratulations, you have a qualifying score on your PAT. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.",
    incompleteDescription:
      "You still need to pass the PAT. Find a PAT to schedule your test.",
    primaryLinkText: "Find a PAT",
    secondaryLinkText: "View Guide",
    secondaryLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST,
  },
}
